<div class="rs-maxh rs-padding-bottom2">
  <div class="panel rs-bg-grey1 rs-no-margin-bottom rs-maxh rs-flex rs-flex-dir-col">
    <h3 class="rs-tit6">{{ 'cloud.subscription.title' | translate }}</h3>
    <div class="rs-flex-row rs-flex-bottom">
      <div class="rs-flex-column">
        <p class="rs-padding-bottom1">
          {{ 'cloud.subscription.cloud' | translate }}
        </p>
      </div>
      <div class="rs-flex-column rs-flex-shrink">
        <p class="rs-padding-bottom1 rs-font-pxB">
          <mprd-price
            *ngIf="fakeCloudOption !== undefined"
            [option]="fakeCloudOption"
            [showActiveStatus]="false"
          ></mprd-price>
        </p>
      </div>
    </div>
    <div class="rs-flex-row rs-flex-bottom">
      <div class="rs-flex-column">
        <p class="rs-padding-bottom1">
          {{ 'cloud.subscription.storageCapacity' | translate }}
        </p>
      </div>
      <div class="rs-flex-column rs-flex-shrink">
        <p class="rs-padding-bottom1 rs-font-pxB">{{ cloudDescription }}</p>
      </div>
    </div>
    <div class="rs-flex-row rs-flex-bottom">
      <div class="rs-flex-column">
        <p class="rs-padding-bottom1">
          {{ 'cloud.subscription.productCode' | translate }}
        </p>
      </div>
      <div class="rs-flex-column rs-flex-shrink">
        <p class="rs-padding-bottom1 rs-font-pxB">{{ serviceId }}</p>
      </div>
    </div>
    <div class="rs-me"></div>
    <div class="rs-flex-grow rs-flex rs-flex-bottom">
      <a
        href="{{ 'cloud.subscription.volume.button.link' | translate }}"
        target="_blank"
        class="rs-btn"
        data-tms-event="button-click"
        attr.data-tms-button-zone="{{ 'cloud.subscription.title' | translate }}"
        attr.data-tms-button-name="{{ 'cloud.subscription.volume.button.label' | translate }}"
        >{{ 'cloud.subscription.volume.button.label' | translate
        }}<i class="icon-Target-Blank rs-margin-left1"
          ><span class="show-for-sr">{{
            'cloud.subscription.volume.link.openWindow.accessibility' | translate
          }}</span></i
        ></a
      >
    </div>
  </div>
</div>
